import { isEmpty } from "lodash";


function getUserLocale(user) {
    if (isEmpty(user)) {
        return null;
    }
    let locale = isEmpty(user.contact.language) ? 'fr' : user.contact.language;
    locale = locale.toLowerCase();
    if (!['fr', 'en', 'de'].includes(locale)) {
        locale = 'en';
    }
    return locale;
}

const getUser = (state) => state.account.userSession.data
const isFetchingUser = (state) => state.account.userSession.isFetching

const editAccountInitialValues = (user) => {
    if(isEmpty(user)){
        return  null
    }

    let country=null;
    if(user.contact.country){
        country = user.contact.country;
        country["titleNormalized"] = country["label"];
        country["title"] = country["label"];

    }


    const initialValues = {
        firstName: user.contact.firstName,
        lastName: user.contact.lastName,
        phoneNumber: !isEmpty(user.contact.phoneNumbers) ? user.contact.phoneNumbers[0] : null,
        language: user.contact.language,
        email: user.contact.email,
        country: country,
        billingAddress: user.billingInformation.address,
        postalCode: user.contact.postalCode,
        optInForNewsletter: user.optIn
    };

    if (user.type === "business") {
        return {
            ...initialValues,
            agencyName: user.name,
            billingName: user.billingInformation.name,
            billingEmail: user.billingInformation.email,
            agencyImage : user.image ? user.image: ""
        };
    }

    return initialValues;
}

export {
    getUserLocale,
    getUser,
    isFetchingUser,
    editAccountInitialValues
}